export default __webpack_public_path__ + "static/media/chevron-right.3252d483.svg";